export enum CustomerStatus {
  PROSPECT = 'prospect',
  NORMAL = 'normal',
  PENDING_CHURN = 'pending-churn',
  DUNNING = 'dunning',
  CHURNED = 'churned',
  ANONYMOUS = 'anonymous',
}
